import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DownloadAuth = {
  booking: boolean;
  schools: boolean;
  teachers: boolean;
  users: boolean;
};

export type AdminAuthority = {
  generateCSV: boolean;
  downloadEmployeeDocs: boolean;
  modifyUserGuides: boolean;
  editBlogs: boolean;
  generalUpload: boolean;
  shop: boolean;
  teachersApproval: boolean;
  vitVerification: boolean;
};

export type EmployeesDocAuth = {
  accreditation: boolean;
  bank: boolean;
  employeeID: boolean;
  identification: boolean;
  super: boolean;
  tax: boolean;
};

interface IUserSlice {
  uid: string | null;
  downloadAuth: DownloadAuth | null;
  userFirstName: string | null;
  adminAuthority: AdminAuthority | null;
  employeeDocAuth: EmployeesDocAuth | null;
}

const initialState: IUserSlice = {
  uid: null,
  downloadAuth: null,
  userFirstName: null,
  adminAuthority: null,
  employeeDocAuth: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLogin: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
    setUserLogout: (state) => {
      state.uid = null;
      state.downloadAuth = null;
      state.userFirstName = null;
      state.adminAuthority = null;
      state.employeeDocAuth = null;
    },
    setDownloadAuth: (state, action: PayloadAction<DownloadAuth | null>) => {
      state.downloadAuth = action.payload;
    },
    setUserFirstName: (state, action: PayloadAction<string | null>) => {
      state.userFirstName = action.payload;
    },
    setAdminAuthority: (
      state,
      action: PayloadAction<AdminAuthority | null>
    ) => {
      state.adminAuthority = action.payload;
    },
    setEmployeeAuth: (
      state,
      action: PayloadAction<EmployeesDocAuth | null>
    ) => {
      state.employeeDocAuth = action.payload;
    },
  },
});

export const {
  setUserLogin,
  setUserLogout,
  setDownloadAuth,
  setUserFirstName,
  setAdminAuthority,
  setEmployeeAuth,
} = userSlice.actions;

export default userSlice.reducer;
